import { useTranslation } from 'react-i18next';
import { usePwaNav } from '../../contexts/PwaNavContext';
import type { FeaturedRestaurantItem } from '../../types/feedMix';
import './FeaturedRestaurantCard.css';

interface Props {
  r: FeaturedRestaurantItem;
}

export function FeaturedRestaurantCard({ r }: Props) {
  const { t } = useTranslation();
  const { navigate } = usePwaNav();

  const distance =
    r.distanceKm == null
      ? null
      : r.distanceKm < 1
        ? t('feed.distanceM', { n: Math.round(r.distanceKm * 1000) })
        : t('feed.distanceKm', { n: r.distanceKm.toFixed(1) });

  return (
    <button
      type="button"
      className="frc-card"
      onClick={() => navigate(`/r/${r.slug}`)}
      aria-label={r.name}
    >
      {r.coverImageUrl ? (
        <img className="frc-img" src={r.coverImageUrl} alt="" loading="lazy" />
      ) : (
        <div className="frc-fallback" aria-hidden />
      )}
      <div className="frc-grad" aria-hidden />
      <span className="frc-badge">{t('feed.featuredBadge', { defaultValue: 'РЕКОМЕНДУЕМ' })}</span>
      <div className="frc-body">
        <div className="frc-name">{r.name}</div>
        <div className="frc-meta">
          {r.cuisine && <span>{r.cuisine}</span>}
          {r.cuisine && distance && <span className="frc-meta-dot" aria-hidden />}
          {distance && <span>{distance}</span>}
        </div>
      </div>
    </button>
  );
}
